var _defs, _clipPath, _path, _path2, _circle, _path3, _g, _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15, _use16, _use17, _use18, _use19, _use20, _use21, _use22, _use23, _use24, _use25, _use26, _use27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1060,
    height: 742,
    viewBox: "-2100 -1470 4200 2940",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", {
    id: "G"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "gcut"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-31.5 0v-70h63v70zm31.5-47v12h31.5v-12z"
  })), /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    clipPath: "url(#gcut)",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5-35H31.5V-25H5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.5-35h10v35h-10z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "R"
  }, /*#__PURE__*/React.createElement("use", {
    width: "100%",
    height: "100%",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 0c0-10 0-32-15-32h-19c22 0 22 22 22 32"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "t",
    transform: "rotate(18,0,-1)",
    d: "m0-1v1h0.5"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "scale(-1,1)",
    width: "100%",
    height: "100%",
    xlinkHref: "#t"
  })), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(72)",
    width: "100%",
    height: "100%",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-72)",
    width: "100%",
    height: "100%",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(144)",
    width: "100%",
    height: "100%",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(216)",
    width: "100%",
    height: "100%",
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star1"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(31.5)",
    width: "100%",
    height: "100%",
    xlinkHref: "#star"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star2"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(26.25)",
    width: "100%",
    height: "100%",
    xlinkHref: "#star"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star3"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(21)",
    width: "100%",
    height: "100%",
    xlinkHref: "#star"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star4"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(15)",
    width: "100%",
    height: "100%",
    xlinkHref: "#star"
  })), /*#__PURE__*/React.createElement("g", {
    id: "star5"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "scale(10.5)",
    width: "100%",
    height: "100%",
    xlinkHref: "#star"
  })), /*#__PURE__*/React.createElement("path", {
    id: "D",
    d: "m-31.5 0h33a30 30 0 0 0 30-30v-10a30 30 0 0 0-30-30h-33zm13-13h19a19 19 0 0 0 19-19v-6a19 19 0 0 0-19-19h-19z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    transform: "translate(-31.5)",
    d: "m0 0h63v-13h-51v-18h40v-12h-40v-14h48v-13h-60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "m-26.25 0h52.5v-12h-40.5v-16h33v-12h-33v-11h39.25v-12h-51.25z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "M",
    d: "m-31.5 0h12v-48l14 48h11l14-48v48h12v-70h-17.5l-14 48-14-48h-17.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "m0 0a31.5 35 0 0 0 0-70 31.5 35 0 0 0 0 70m0-13a18.5 22 0 0 0 0-44 18.5 22 0 0 0 0 44",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "P",
    d: "m-31.5 0h13v-26h28a22 22 0 0 0 0-44h-40zm13-39h27a9 9 0 0 0 0-18h-27z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "S",
    d: "m-15.75-22c0 7 6.75 10.5 16.75 10.5s14.74-3.25 14.75-7.75c0-14.25-46.75-5.25-46.5-30.25 0.25-21.5 24.75-20.5 33.75-20.5s26 4 25.75 21.25h-15.25c0-7.5-7-10.25-15-10.25-7.75 0-13.25 1.25-13.25 8.5-0.25 11.75 46.25 4 46.25 28.75 0 18.25-18 21.75-31.5 21.75-11.5 0-31.55-4.5-31.5-22z"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "band"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 735
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m-2100-1470h4200v2940h-4200z",
    fill: "#009b3a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M -1743,0 0,1113 1743,0 0,-1113 Z",
    fill: "#fedf00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 735,
    fill: "#002776"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m-2205 1470a1785 1785 0 0 1 3570 0h-105a1680 1680 0 1 0-3360 0z",
    clipPath: "url(#band)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-420,1470)",
    fill: "#009b3a"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-7)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-4)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(-1)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#D"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(2)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#M"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(9.75)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(14.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#P"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(17.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(20.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#O"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(23.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#G"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(26.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#R"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(29.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#E"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(32.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#S"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(35.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#S"
  }), /*#__PURE__*/React.createElement("use", {
    transform: "rotate(38.5)",
    y: -1697.5,
    width: "100%",
    height: "100%",
    xlinkHref: "#O"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMi",
    x: -600,
    y: -132,
    width: "100%",
    height: "100%",
    xlinkHref: "#star1"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1CMa",
    x: -535,
    y: 177,
    width: "100%",
    height: "100%",
    xlinkHref: "#star1"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2CMa",
    x: -625,
    y: 243,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3CMa",
    x: -463,
    y: 132,
    width: "100%",
    height: "100%",
    xlinkHref: "#star4"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4CMa",
    x: -382,
    y: 250,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5CMa",
    x: -404,
    y: 323,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Vir",
    x: 228,
    y: -228,
    width: "100%",
    height: "100%",
    xlinkHref: "#star1"
  })), _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Sco",
    x: 515,
    y: 258,
    width: "100%",
    height: "100%",
    xlinkHref: "#star1"
  })), _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Sco",
    x: 617,
    y: 265,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Sco",
    x: 545,
    y: 323,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B8Sco",
    x: 368,
    y: 477,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B9Sco",
    x: 367,
    y: 551,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BASco",
    x: 441,
    y: 419,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BBSco",
    x: 500,
    y: 382,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03BCSco",
    x: 365,
    y: 405,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use16 || (_use16 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Hya",
    x: -280,
    y: 30,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use17 || (_use17 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Hya",
    x: 200,
    y: -37,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use18 || (_use18 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Cru",
    y: 330,
    width: "100%",
    height: "100%",
    xlinkHref: "#star1"
  })), _use19 || (_use19 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2Cru",
    x: 85,
    y: 184,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use20 || (_use20 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3Cru",
    y: 118,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use21 || (_use21 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B4Cru",
    x: -74,
    y: 184,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use22 || (_use22 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B5Cru",
    x: -37,
    y: 235,
    width: "100%",
    height: "100%",
    xlinkHref: "#star4"
  })), _use23 || (_use23 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1TrA",
    x: 220,
    y: 495,
    width: "100%",
    height: "100%",
    xlinkHref: "#star2"
  })), _use24 || (_use24 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B2TrA",
    x: 283,
    y: 430,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use25 || (_use25 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B3TrA",
    x: 162,
    y: 412,
    width: "100%",
    height: "100%",
    xlinkHref: "#star3"
  })), _use26 || (_use26 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03B1Car",
    x: -295,
    y: 390,
    width: "100%",
    height: "100%",
    xlinkHref: "#star1"
  })), _use27 || (_use27 = /*#__PURE__*/React.createElement("use", {
    id: "\\u03C3Oct",
    y: 575,
    width: "100%",
    height: "100%",
    xlinkHref: "#star5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrFlag);
export default __webpack_public_path__ + "static/media/BRFlag.2f483b978b6584477edf73b55fd36763.svg";
export { ForwardRef as ReactComponent };